import { render, staticRenderFns } from "./EmpresaForm.vue?vue&type=template&id=ca23a8ba"
import script from "./EmpresaForm.vue?vue&type=script&lang=js"
export * from "./EmpresaForm.vue?vue&type=script&lang=js"
import style0 from "./EmpresaForm.vue?vue&type=style&index=0&id=ca23a8ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports